export const Rivers = [
	{
		title: "Arkansas River",
		src: "/Arkansas",
		about:
			"Stemming from up high at Leadville, this river has a bit of it all for any angler. Wild trout forage on prolific hatches ranging from the legendary golden stone to insane numbers of caddis flies, and much more in between. Whether you are stalking the small water by foot or floating down some heavy whitewater, the Arkansas is a special river that we all adore.",
		Sites: ["ARKSALCO", "ARKLEACO", "ARKPUECO"],
		cordinates: { lad: "39.545", long: "-106.0107" },
		imageRef: require("../Photos/RiverReport/ark.jpg"),
		mapRefs: [
			{
				name: "ARKANSAS RIVER AT SALIDA, CO.",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3120.4736374523063!2d-106.01288868491969!3d38.54589997962638!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzjCsDMyJzQ1LjIiTiAxMDbCsDAwJzM4LjUiVw!5e0!3m2!1sen!2sus!4v1605748995102!5m2!1sen!2sus",
			},
			{
				name: "ARKANSAS RIVER NEAR LEADVILLE, CO",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3089.7300176604317!2d-106.35018868489641!3d39.24899997951796!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDE0JzU2LjQiTiAxMDbCsDIwJzUyLjgiVw!5e0!3m2!1sen!2sus!4v1605748948303!5m2!1sen!2sus",
			},
			{
				name: "ARKANSAS RIVER ABOVE PUEBLO",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3132.3474914223384!2d-104.72073968492866!3d38.271436979671954!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzjCsDE2JzE3LjIiTiAxMDTCsDQzJzA2LjgiVw!5e0!3m2!1sen!2sus!4v1605819907016!5m2!1sen!2sus",
			},
		],
	},
	{
		title: "Big Thompson",
		src: "/BigThompson",
		Sites: ["BTBLESCO", "BTBMORCO", "BTNFDRCO"],
		about:
			"The Big Thompson River is a short drive from Boulder and has almost 10 miles of access along highway 34 between Lake Estes and the town of Drake; and over half of this is public water.  There is another 10 miles of water between Drake and Loveland in the lower canyon, but as you get closer to Loveland the public access diminishes.  Great midges throughout the winter, and a wide variety of hatches through the summer keep this front range stream on everyones list. Evenings in the summertime can be a great time to visit this one.",
		cordinates: { lad: "40.376373", long: "-105.485553" },
		imageRef: require("../Photos/RiverReport/BigT.jpg"),
		mapRefs: [
			{
				name: "BIG THOMPSON RIVER BELOW LAKE ESTES",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3039.465570487315!2d-105.4877416847894!3d40.376372979369826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDIyJzM0LjkiTiAxMDXCsDI5JzA4LjAiVw!5e0!3m2!1sen!2sus!4v1592772627649!5m2!1sen!2sus",
			},
			{
				name: "NORTH FORK BIG THOMPSON RIVER AT DRAKE, CO.",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3036.8821686940055!2d-105.34803568478749!3d40.433607979363146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDI2JzAxLjAiTiAxMDXCsDIwJzQ1LjEiVw!5e0!3m2!1sen!2sus!4v1592773011746!5m2!1sen!2sus",
			},
		],
	},
	{
		title: "Blue River",
		src: "/BlueRiver",
		Sites: ["BLUDILCO", "BLUGRECO"],
		about:
			"The Blue is a true gem of a fishery in Summit County. This river originates as a freestone stream high in the mountains and culminates in a series of tailwater fisheries known for producing some of our area’s largest trout. The tailwater section below Dillon Reservoir is a Mysis shrimp fishery where, depending on flows, technical midge rigs can be the ticket. Downstream from Silverthorne, more solitude can be found on this tributary that feeds into the Colorado River.",
		cordinates: { lad: "39.880264", long: "-106.333918" },
		imageRef: require("../Photos/RiverReport/blue.jpg"),
		mapRefs: [
			{
				name: "BLUE RIVER BELOW DILLON, CO.",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3073.0738067302213!2d-106.06859668481407!3d39.625541979464984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDM3JzMyLjAiTiAxMDbCsDAzJzU5LjEiVw!5e0!3m2!1sen!2sus!4v1603827866714!5m2!1sen!2sus",
			},
			{
				name: "BLUE RIVER BELOW GREEN MOUNTAIN RESERVOIR, CO",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3061.730957380667!2d-106.3361066848058!3d39.88026397943104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDUyJzQ5LjAiTiAxMDbCsDIwJzAyLjEiVw!5e0!3m2!1sen!2sus!4v1603827779341!5m2!1sen!2sus",
			},
		],
	},
	{
		title: "Boulder Creek",
		src: "/BoulderCreek",
		Sites: ["BOCOROCO", "BOCMIDCO"],
		cordinates: { lad: "40.0086", long: "-105.331" },
		imageRef: require("../Photos/RiverReport/MarkLewis-2248s.jpg"),
		mapRefs: [
			{
				name: "BOULDER CREEK NEAR ORODELL, CO.",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7593.790772726956!2d-105.33195199271685!3d40.008653524872635!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDAwJzIzLjAiTiAxMDXCsDE5JzUxLjAiVw!5e0!3m2!1sen!2sus!4v1587488096219!5m2!1sen!2sus",
			},
			{
				name: "MIDDLE BOULDER CREEK AT NEDERLAND, CO.",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1975.8737485566396!2d-105.50591828061874!3d39.96152734001826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDU3JzQyLjAiTiAxMDXCsDMwJzE0LjAiVw!5e0!3m2!1sen!2sus!4v1591129207472!5m2!1sen!2sus",
			},
		],
		about:
			"Just blocks from the shop, Boulder Creek is our home water with great access through town as well as  the many pull offs along HWY 119 throughout Boulder Canyon.  Chocked full of trout averaging 8-12 inches, these browns and rainbows are known for their willingness to attack a fly throughout much of the year.  This small stream can be fished effectively most often with a dry dropper set up, and has great hatches March- October.",
	},
	{
		title: "Clear Creek",
		src: "/ClearCreek",
		Sites: ["CLEGOLCO", "CLELAWCO"],
		about:
			"Here is a great local fishery that is especially convenient for Denver residents who are looking to get out for a nice day session close to home. While overlooked by some due to its proximity to highways, Clear Creek is a great fishery where wild browns and ‘bows tend to be eager takers on the dry fly and on dry-dropper rigs. The sections in Clear Creek Canyon between Golden to the I-70 corridor are the closest option, but don’t miss out on publically accessible stretches of water located up toward Idaho Springs, Georgetown, and beyond. This is another pocket water paradise where you’ll often find best numbers caught by presenting the fly to as many as fish possible and working through a lot of pockets and pools, maximizing the numbers of potential takers that are seeing your flies.",
		cordinates: { lad: "39.753043", long: "-105.235267" },
		imageRef: require("../Photos/RiverReport/clear.jpeg"),
		mapRefs: [
			{
				name: "CLEAR CREEK AT GOLDEN, CO",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067.4037260544833!2d-105.23745568487952!3d39.75304297944781!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDQ1JzExLjAiTiAxMDXCsDE0JzA3LjAiVw!5e0!3m2!1sen!2sus!4v1605750454450!5m2!1sen!2sus",
			},
			{
				name: "CLEAR CREEK NEAR LAWSON, CO",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3066.8346393497527!2d-105.62830068487908!3d39.765820979446154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDQ1JzU3LjAiTiAxMDXCsDM3JzM0LjAiVw!5e0!3m2!1sen!2sus!4v1605819758842!5m2!1sen!2sus",
			},
		],
	},
	{
		title: "Colorado River",
		src: "/Colorado",
		Sites: ["COLKRECO", "COLPARCO", "COLGBYCO"],
		stationNames: [],
		FlowData: [],
		about:
			"One of our country’s most-known rivers, the Colorado shouldn’t be missed. This river is potentially the most diverse of them all, giving anglers the opportunity to find solitude and be one cast away from a trophy catch. Whether you are chasing the legendary salmon fly hatch or wanting to spend some time exploring its numerous canyon settings, we’ve got you covered! With great wade fishing, float fishing, and great camping access, make sure you check out the Collie.",
		cordinates: { lad: "40.036652", long: "-106.440032" },
		imageRef: require("../Photos/RiverReport/colo.jpg"),
		mapRefs: [
			{
				name: "COLORADO RIVER NEAR KREMMLING, CO",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50108.17689396918!2d-106.49081226870453!3d40.0469066907862!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDAyJzEyLjAiTiAxMDbCsDI2JzI0LjEiVw!5e0!3m2!1sen!2sus!4v1603828016421!5m2!1sen!2sus",
			},
			{
				name: "COLORADO RIVER NEAR PARSHALL BELOW W.F. CONFLUENCE",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3053.567177343407!2d-106.19471568479972!3d40.062758979407825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDAzJzQ1LjkiTiAxMDbCsDExJzMzLjEiVw!5e0!3m2!1sen!2sus!4v1603833492078!5m2!1sen!2sus",
			},
			{
				name: "COLORADO RIVER BELOW LAKE GRANBY, CO.",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3049.89857286425!2d-105.86943268479705!3d40.14454297939765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDA4JzQwLjQiTiAxMDXCsDUyJzAyLjEiVw!5e0!3m2!1sen!2sus!4v1603833647263!5m2!1sen!2sus",
			},
		],
	},
	{
		title: "Eagle River",
		src: "/Eagle",
		Sites: ["EAGMILCO", "EAGGYPCO"],
		about:
			"A tributary of the Colorado River, the Eagle remains as one the last true freestone rivers.  Hard fighting rainbows and browns will test your gear, and even your skillset as an angler.  Highway 6 will allow you to access many beats, and dispersed camping is always a bonus.  Give this river a shot if you are heading over Vail pass and want to get some!",
		cordinates: { lad: "39.705", long: "-106.725833" },
		imageRef: require("../Photos/RiverReport/eagle2.jpg"),
		mapRefs: [
			{
				name: "EAGLE RIVER BELOW MILK CREEK NEAR WOLCOTT, CO",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3069.5420251414653!2d-106.72802168481145!3d39.70499997945423!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDQyJzE4LjAiTiAxMDbCsDQzJzMzLjAiVw!5e0!3m2!1sen!2sus!4v1603917026459!5m2!1sen!2sus",
			},
			{
				name: "EAGLE RIVER BELOW GYPSUM, CO.",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3797.320784903974!2d-106.95512878794362!3d39.649688571376814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDM4JzU4LjAiTiAxMDbCsDU3JzEzLjIiVw!5e0!3m2!1sen!2sus!4v1603917166684!5m2!1sen!2sus",
			},
		],
	},
	{
		title: "Rocky Mountain National Park",
		src: "/RMNP",
		Sites: ["BTBMORCO"],
		about:
			"The Park is our bread and butter for spring-fall fishing in the high country, with high alpine lakes full of native greenback cutts, small streams filled with eager brook trout, larger browns lurking under cut-banks, and much more. A backdrop of beautiful mountain scenery is a constant when fishing the small streams and stillwater fisheries the Park has to offer, and sightings of wild animals like elk, moose, and even the occasional big horn sheep are common. RMNP is renowned for its dry fly fishing, which tends to peak from roughly July to September when we’ve passed the high-water runoff period of spring and beetles, ants, hoppers, caddis, and other bugs are in abundant supply for these wild, self-sustaining trout. A shop favorite on full-day guide trips is to go for the “Rocky Mountain Grand Slam” – catching all four available trout species of brook, brown, rainbow, and cutthroat in a single day.",
		cordinates: { lad: "40.353873", long: "105.584168" },
		imageRef: require("../Photos/RiverReport/MorainePark.jpg"),
		mapRefs: [
			{
				name: "BIG THOMPSON BL MORAINE PARK NR ESTES PARK, CO",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3040.4803169420684!2d-105.58635668485906!3d40.35387297937243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDIxJzEzLjkiTiAxMDXCsDM1JzAzLjAiVw!5e0!3m2!1sen!2sus!4v1605750019030!5m2!1sen!2sus",
			},
		],
	},
	{
		title: "South Boulder Creek",
		src: "/SouthBoulderCreek",
		about:
			"We call the SBC tailwater “the bug factory” and she really hits her “buggy” prime in late July through September with drakes, PMD’s, caddis, quills, and stoneflies.  Flows can fluctuate dramatically through this stretch of water, so be sure to check flows before you go.  Only 12 miles from the shop, the Walker Ranch stretch of water can have you feeling 100 miles from anywhere.  A great spot to hike away from the crowds for more of a wilderness experience.",
		Sites: ["BOCBGRCO", "MOFTUNCO", "BOCELSCO"],
		cordinates: { lad: "39.940490", long: "-105.344903" },
		imageRef: require("../Photos/RiverReport/sbc.jpg"),
		mapRefs: [
			{
				name: "SOUTH BOULDER CREEK BELOW GROSS RESERVOIR",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1529.5509565790776!2d-105.34762502409225!3d39.93910999483063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDU2JzIwLjgiTiAxMDXCsDIwJzQ3LjUiVw!5e0!3m2!1sen!2sus!4v1587488878041!5m2!1sen!2sus",
			},
			{
				name: "MOFFAT WATER TUNNEL AT EAST PORTAL, CO.",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3539.949604125498!2d-105.64734290218865!3d39.90214551078216!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876bc9d493ce876b%3A0x2d9b60fa8b908e34!2sMoffat%20Tunnel%20-%20East%20Portal!5e0!3m2!1sen!2sus!4v1591123447601!5m2!1sen!2sus",
			},
			{
				name: "SOUTH BOULDER CREEK NEAR ELDORADO SPRINGS, CO.",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3059.378332169922!2d-105.30744148511347!3d39.93292629284542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDU1JzU4LjUiTiAxMDXCsDE4JzE4LjkiVw!5e0!3m2!1sen!2sus!4v1591123600048!5m2!1sen!2sus",
			},
		],
	},
	{
		title: "South Platte",
		src: "/SouthPlatte",
		Sites: ["PLACHECO"],
		about:
			"Perhaps one of the most-known stretches of water close to Denver, the South Platte should be on your list. Fooling a well-educated trout on light tackle is always something to brag about, and this is where you can get that done. Impressive hatches and gorgeous scenery are just some of the reasons to venture out to the Platte. Whether you’re looking for world-class nymph fishing or the chance to present a small dry fly to a trophy-sized trout sipping on the surface, this river has something for you.",
		cordinates: { lad: "39.209275", long: "-105.268136" },
		imageRef: require("../Photos/RiverReport/cheeseman.jpg"),
		mapRefs: [
			{
				name: "SOUTH PLATTE RIVER BELOW CHEESMAN RESERVOIR ",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5999.635623457982!2d-105.26987044723136!3d39.20986934683221!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDEyJzMzLjQiTiAxMDXCsDE2JzA1LjMiVw!5e0!3m2!1sen!2sus!4v1603813047667!5m2!1sen!2sus",
			},
		],
	},
	{
		title: "St. Vrain",
		src: "/StVrain",
		Sites: ["SVCLYOCO", "SSVWARCO", "NSVBBRCO", "MIDSTECO"],
		about:
			"The St. Vrain and its many forks flow through the town of Lyons and offer unique angling opportunities right on the Front Range. With headwaters in Rocky Mountain National Park, the North St. Vrain is popularly accessed at the Wild Basin entrance, a small stream setting that can be extremely productive with small attractor dries. Brook trout and brown trout will be the main target here, with cutthroat also present. The South St. Vrain is accessed just outside the town of Lyons and also has great fishing opportunities by using pull-offs and parking areas as your way to the water. As all these forks meet in the town of Lyons, you can fish the main stem of the St. Vrain right through town, where deeper pools and runs are home to many trout! Give this local stream a shot if you haven’t, especially if you want to be in a pretty area with gorgeous mountain views and willing trout.",
		cordinates: { lad: "40.218043", long: "-105.260001" },
		imageRef: require("../Photos/RiverReport/stvrain.jpg"),
		mapRefs: [
			{
				name:
					"NORTH SAINT VRAIN CREEK BELOW BUTTONROCK  (RALPH PRICE) RESERVOIR",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3046.7034990261295!2d-105.36561068479469!3d40.215657979388936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDEyJzU2LjQiTiAxMDXCsDIxJzQ4LjMiVw!5e0!3m2!1sen!2sus!4v1592503191094!5m2!1sen!2sus",
			},
			{
				name: "MIDDLE SAINT VRAIN AT PEACEFUL VALLEY",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3050.560093205826!2d-105.51929968479756!3d40.1298059793995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDA3JzQ3LjMiTiAxMDXCsDMxJzAxLjYiVw!5e0!3m2!1sen!2sus!4v1592502814734!5m2!1sen!2sus",
			},
			{
				name: "SOUTH SAINT VRAIN NEAR WARD",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2726.402897388244!2d-105.51611187738058!3d40.09104290096642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDA1JzI3LjAiTiAxMDXCsDMwJzUyLjAiVw!5e0!3m2!1sen!2sus!4v1592503088511!5m2!1sen!2sus",
			},
			{
				name: "SAINT VRAIN CREEK AT LYONS, CO",
				mapRef:
					"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3046.596263732503!2d-105.26218968479465!3d40.21804297938875!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDEzJzA1LjAiTiAxMDXCsDE1JzM2LjAiVw!5e0!3m2!1sen!2sus!4v1592501175740!5m2!1sen!2sus",
			},
		],
	},
];
//aboutReports:
//"Casting a fly in a tranquil mountain stream, feeling the tug on the line, and holding a beautiful rainbow trout makes us feel alive and intensely connected with nature. Fly fishing is our way of life and we are blessed with hundreds of nearby rivers and streams just a short distance away from Boulder. From the swift spring waters of the Clear Creek to the meandering bends of the South Platte, it's critical to consider fishing conditions in advance and prepare accordingly. We rely on our experienced guides who venture into the wild to let us know which rivers favor fly fishing, where fish are biting, and which fly patterns are most effective. Planning a successful fishing trip also requires knowledge of stream flows at various river points and an accurate weather forecast for a given destination. At Rocky Mountain Anglers, we are dedicated to providing all avid anglers with detailed and timely information about hatches, water, and weather conditions. So before you head out the door on your next fishing adventure, visit our web site to find valuable information that will prepare you for a successful trip. Have fun chasing after your next trophy trout and enjoy nature's beauty!",
